import { render, staticRenderFns } from "./AlarmView.vue?vue&type=template&id=3b237c56"
import script from "./AlarmView.vue?vue&type=script&lang=js"
export * from "./AlarmView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports